import { InferValueTypes } from "../service-types";
import * as actions from "./actions";

export enum PendingContractAction {
  GET_PENDING_CONTRACT_RECORD = "GET_PENDING_CONTRACT_RECORD",
  SET_PENDING_CONTRACT_RECORD = "SET_PENDING_CONTRACT_RECORD",
  CREATE_PENDING_CONTRACT = "CREATE_PENDING_CONTRACT",
  IMPORT_PENDING_CONTRACT = "IMPORT_PENDING_CONTRACT",
  UPLOAD_DOCUMENTS = "UPLOAD_DOCUMENTS",
  CLEAN_UP = "PENDING_CONTRACT_STATE_CLEAN_UP",
  SET_UPLOADED_DOCUMENTS = "SET_UPLOADED_DOCUMENTS",
}

export interface PendingContractState {
  id: string;
  purchaseDate: Date | null;
  customerFirstName: string;
  customerLastName: string;
  customerAddress: string;
  storeName: string;
  salesPerson: string;
  invoiceImg: string;
  invoiceNumber: string;
  contractPurchaseDate: Date | null;
  recordType: string;
  sellingStoreLocation: string;
  sellingStoreAddress: string;
  sellingStoreCity: string;
  sellingStoreState: string;
  sellingStorePostalCode: string;
  sellingStoreCountryCode: string;
  salesPersonId: string;
  customerId: string;
  customerStreetAddress1: string;
  customerStreetAddress2: string;
  customerCity: string;
  customerState: string;
  customerPostalCode: string;
  customerCountryCode: string;
  customerEmail: string;
  customerPrimaryTelephone: string;
  customerAlternativeTelephone: string;
  customerDeliveryStreetAddress1: string;
  customerDeliveryStreetAddress2: string;
  customerDeliveryCity: string;
  customerDeliveryState: string;
  customerDeliveryPostalCode: string;
  customerDeliveryCountryCode: string;
  contractRetailPrice: number;
  totalProductRetailValue: number;
  originalTransactionId: string | null;
  originalDealerStoreId: string | null;
  originalContractPurchaseDate: Date | null;
  protectallSku: string;
  documents: string[];
  lineItems: LineItems[];
  // uploadedInvoice?: string | null;
}

export interface LineItems {
  id: string;
  manufacturer: string;
  modelNumber: string;
  serialNumber: string;
  purchaseDateOfProduct: Date | null;
  deliveryDateOfProduct: Date | null;
  productRetailPrice: number;
  quantity: number;
  productSku: string;
  productDescription: string;
  productQuality: string;
}

export const PendingContractScope = "pendingContract";

export type PendingContractActionTypes = ReturnType<
  InferValueTypes<typeof actions>
>;
